module.exports = __webpack_public_path__ + "img/twitter.5da75b22.png";